var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResetDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1475 9.9425C11.3422 10.1372 11.3422 10.4528 11.1475 10.6475C10.9528 10.8422 10.6372 10.8422 10.4425 10.6475L9 9.205L7.5575 10.6475C7.36282 10.8422 7.04718 10.8422 6.8525 10.6475C6.65782 10.4528 6.65782 10.1372 6.8525 9.9425L8.295 8.5L6.8525 7.0575C6.65782 6.86282 6.65782 6.54718 6.8525 6.3525C7.04718 6.15782 7.36282 6.15782 7.5575 6.3525L9 7.795L10.4425 6.3525C10.6372 6.15782 10.9528 6.15782 11.1475 6.3525C11.3422 6.54718 11.3422 6.86282 11.1475 7.0575L9.705 8.5L11.1475 9.9425ZM13 4C13.2652 4 13.5196 4.10536 13.7071 4.29289C13.8946 4.48043 14 4.73478 14 5V12C14 12.2652 13.8946 12.5196 13.7071 12.7071C13.5196 12.8946 13.2652 13 13 13H5.5C5.155 13 4.885 12.82 4.705 12.555L2.36996 9.05459C2.14593 8.71876 2.14581 8.28116 2.36964 7.94519L4.705 4.44C4.885 4.175 5.155 4 5.5 4H13ZM13 5H5.5L3.14 8.5L5.5 12H13V5Z",
    fill: "#2C303B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetDark);
export default __webpack_public_path__ + "static/media/reset-dark.1574e5a262487d144a17f0edb3b43997.svg";
export { ForwardRef as ReactComponent };